<ng-container *transloco="let t">
  @if (label()) {
  <div [class]="labelClass()">
    <label [for]="controlId()" class="text-xs font-medium text-ink tracking-tight">
      {{ t(label()) }} @if (!disabled() && required()) {
      <span class="text-danger" aria-hidden="true"> *</span>
      }
    </label>
  </div>
  }

  <div #origin class="juno-country-picker__trigger" [class]="appliedClasses() || ''">
    @if (selectedCountry()) {
    <img
      class="juno-country-picker__flag"
      [src]="selectedCountry()!.flagUrl"
      [alt]="selectedCountry()!.localName"
      width="20"
      height="14"
    />
    }

    <input
      type="text"
      ngCombobox
      #combobox="ngCombobox"
      #comboboxInput
      class="juno-country-picker__input"
      [class.juno-country-picker__input--has-flag]="selectedCountry()"
      [class.input-error]="showError()"
      [class.disabled]="disabled()"
      [id]="controlId()"
      [name]="controlId()"
      [placeholder]="placeholder() ? t(placeholder()) : ''"
      [disabled]="disabled()"
      [readonly]="pending()"
      [expanded]="popupExpanded()"
      [(value)]="filterText"
      [attr.aria-label]="label() ? null : t(ariaLabel()) || null"
      [attr.aria-required]="required()"
      [attr.aria-busy]="pending()"
      [attr.aria-invalid]="showError()"
      [attr.aria-describedby]="showError() ? controlId() + '-error' : null"
      (expandedChange)="onExpandedChange($event)"
      (click)="openDropdown()"
    />

    <mat-icon
      svgIcon="alt-arrow-down-outline"
      class="juno-country-picker__chevron"
      [class.juno-country-picker__chevron--open]="popupExpanded()"
      aria-hidden="true"
    ></mat-icon>
  </div>

  <ng-template
    [cdkConnectedOverlay]="{ origin: origin, matchWidth: false, usePopover: 'inline' }"
    [cdkConnectedOverlayOpen]="popupExpanded()"
    (overlayOutsideClick)="onExpandedChange(false)"
    (detach)="onExpandedChange(false)"
  >
    <ng-template ngComboboxPopup [combobox]="combobox">
      <ul
        ngListbox
        ngComboboxWidget
        #listbox="ngListbox"
        [tabindex]="-1"
        focusMode="activedescendant"
        selectionMode="explicit"
        [value]="listboxValue()"
        [activeDescendant]="listbox.activeDescendant()"
        (valueChange)="onListboxValueChange($event)"
        (wheel)="onDropdownWheel($event)"
        animate.enter="juno-country-picker__list--enter"
        animate.leave="juno-country-picker__list--leave"
        class="juno-country-picker__list"
      >
        @for (country of filteredCountries(); track country.code) {
        <li ngOption [value]="country.code" [label]="country.code" class="juno-country-picker__option">
          <img
            loading="lazy"
            [src]="country.flagUrl"
            [alt]="country.localName"
            width="20"
            height="14"
            class="shrink-0"
          />
          <span class="uppercase font-medium text-sm">{{ country.code }}</span>
          <span class="text-xs text-ink-muted ms-auto">+{{ country.isdCode }}</span>
        </li>
        } @empty {
        <li class="juno-country-picker__no-results" aria-live="polite">{{ t('NO-RESULTS') }}</li>
        }
      </ul>
    </ng-template>
  </ng-template>

  @if (showError()) {
  <div [id]="controlId() + '-error'" role="alert">
    <juno-libs-ui-error [errors]="errors()"></juno-libs-ui-error>
  </div>
  }
</ng-container>
